﻿import { Analytics } from './analytics';

document.addEventListener('DOMContentLoaded', () => {
    const attachEventListeners = () => {
        document.querySelectorAll('[data-buy-now-tracker-model]').forEach(button => {
            if (!button.hasAttribute('data-event-attached')) {
                button.addEventListener('click', (event) => {
                    const target = event.currentTarget as HTMLElement;
                    const itemId = target.getAttribute('data-buy-now-tracker-id');
                    const itemName = target.getAttribute('data-buy-now-tracker-display-name');
                    const itemBrand = target.getAttribute('data-buy-now-tracker-brand');
                    const itemPrice = parseFloat(target.getAttribute('data-buy-now-tracker-price') || '0');
                    const itemCategory = target.getAttribute('data-buy-now-tracker-category');
                    const areaOfActivity = target.getAttribute('data-buy-now-tracker-areaofactivity');
                    const itemVariant = target.getAttribute('data-buy-now-tracker-variant');
                    const affiliation = target.getAttribute('data-buy-now-tracker-affiliation');
                    const quantity = parseInt(target.getAttribute('data-buy-now-tracker-quantity') || '1');


                    Analytics.sendRawEvent({
                        event: 'intent_item',
                        ecommerce: {
                            items: [{
                                item_id: itemId,
                                item_name: itemName,
                                affiliation: affiliation,
                                item_brand: itemBrand,
                                item_category: itemCategory,
                                area_of_activity: areaOfActivity,
                                item_variant: itemVariant,
                                price: itemPrice,
                                quantity: quantity
                            }]
                        }
                    });
                });
                button.setAttribute('data-event-attached', 'true');
            }
        });
    };

    const storeItemList = document.querySelector('.store-item-list');
    if (storeItemList) {
        // Attach event listeners to existing elements
        attachEventListeners();

        // Observe the store-item-list for changes and attach event listeners to new elements
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    attachEventListeners();
                    observer.disconnect();
                }
            });
        });

        observer.observe(storeItemList, { childList: true, subtree: true });
    }
});
